module.exports = __webpack_public_path__ + "img/u129.4ed53aba.svg";